// A criterion value can be a string, number, boolean or object (see CriterionDto in
// rule-assessment-service). React can't render objects and silently drops booleans,
// so turn every value into display text before it reaches a grid cell.
export const formatCriterionValue = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
